const setUpHomeIntroductionParallax = () => {
  const hero = document.querySelector(".home-hero-banner.image-banner");
  const intro = document.querySelector(".home-introduction");

  if (!(hero instanceof HTMLElement) || !(intro instanceof HTMLElement)) {
    return;
  }

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  if (prefersReducedMotion.matches) {
    return;
  }

  const maxLiftPx = 90;
  let baseMarginTop = 0;
  let baseMinHeight = 0;
  let ticking = false;

  const recalculateBaseValues = () => {
    intro.style.marginTop = "";
    intro.style.minHeight = "";

    const styles = window.getComputedStyle(intro);
    const parsedMarginTop = Number.parseFloat(styles.marginTop);
    const parsedMinHeight = Number.parseFloat(styles.minHeight);

    baseMarginTop = Number.isFinite(parsedMarginTop) ? parsedMarginTop : -20;
    baseMinHeight = Number.isFinite(parsedMinHeight)
      ? parsedMinHeight
      : intro.getBoundingClientRect().height;
  };

  const update = () => {
    const heroHeight = Math.max(hero.getBoundingClientRect().height, 1);
    const progress = Math.min(Math.max(window.scrollY / heroHeight, 0), 1);
    const lift = Math.round(progress * maxLiftPx);

    // Grow upward only: lift the top edge while keeping the bottom edge anchored.
    intro.style.marginTop = `${baseMarginTop - lift}px`;
    intro.style.minHeight = `${baseMinHeight + lift}px`;
    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(update);
  };

  recalculateBaseValues();
  intro.style.willChange = "margin-top, min-height";
  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", () => {
    recalculateBaseValues();
    requestUpdate();
  });
  requestUpdate();
};

export default setUpHomeIntroductionParallax;
